import React from 'react';

const Conditions = (props) => {
  const { info } = props;

  const feels = info.app_temp;
  const humidity = info.rh;
  const windKph = info.wind_spd;
  const stateDay = info.weather.description;
  return (
    <ul className="conditions">
      <li key="1" data-i18n={`weather.${stateDay}`}>
        {stateDay}
      </li>
      <li key="2">
        <span data-i18n="conditions.feels">Feels like:</span> {feels}°
      </li>
      <li key="3">
        <span data-i18n="conditions.wind">Wind:</span> {windKph.toFixed(1)} km/h{' '}
      </li>
      <li key="4">
        <span data-i18n="conditions.humidity">Humidity:</span> {humidity}%
      </li>
    </ul>
  );
};

export default Conditions;
